export const CraftLink = () => import('../../../components/CraftLink.vue' /* webpackChunkName: "components/craft-link" */).then(c => wrapFunctional(c.default || c))
export const EventProgramTable = () => import('../../../components/EventProgramTable.vue' /* webpackChunkName: "components/event-program-table" */).then(c => wrapFunctional(c.default || c))
export const EventProgramTableItem = () => import('../../../components/EventProgramTableItem.vue' /* webpackChunkName: "components/event-program-table-item" */).then(c => wrapFunctional(c.default || c))
export const EventProgramTableItemSpeaker = () => import('../../../components/EventProgramTableItemSpeaker.vue' /* webpackChunkName: "components/event-program-table-item-speaker" */).then(c => wrapFunctional(c.default || c))
export const CrossSell = () => import('../../../components/CrossSell/CrossSell.vue' /* webpackChunkName: "components/cross-sell" */).then(c => wrapFunctional(c.default || c))
export const CrossSellOverview = () => import('../../../components/CrossSellOverview/CrossSellOverview.vue' /* webpackChunkName: "components/cross-sell-overview" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
